import { getExtension, languages } from '../../constants/languages';
import { isString } from '../type-utils';

export function getFileLanguage(file) {
  if (!file || !file.path) return '';
  const lang = languages.langFromFilename(file.path);
  return lang ? lang.id : getExtension(file.path);
}

export function getFileIcon(file) {
  if (!file) return '';
  if (isString(file.icon)) return file.icon;
  return file.directory ? '' : 'lang-' + getFileLanguage(file);
}

export function splitPath(path) {
  path = path || '';
  // clean up and split path
  const pathParts = path.replace(/^\/+|\/+$/g, '').split('/');
  const filename = pathParts.pop();
  return { pathParts, filename };
}

export function parentPath(path) {
  return splitPath(path).pathParts.join('/');
}

export function cleanPath(path) {
  path = path || '';
  return path
    .replace(/[\\\/]+/g, '/') // ensure correct slashes, and remove duplicate slashes
    .replace(/^\/|\/$/g, '') // remove leading and trailing slashes
    .replace(/(^|\/)\.\.+\//g, '/'); // strip relative path expressions
}
